import AddBusinessIcon from "@mui/icons-material/AddBusiness";

const AddBusiness = (props: any) => {
  return <AddBusinessIcon {...props} />;
};

export default AddBusiness;
